import { render, staticRenderFns } from "./layoutReqDoc.vue?vue&type=template&id=4923ca24&scoped=true"
import script from "./layoutReqDoc.vue?vue&type=script&lang=js"
export * from "./layoutReqDoc.vue?vue&type=script&lang=js"
import style0 from "./layoutReqDoc.vue?vue&type=style&index=0&id=4923ca24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4923ca24",
  null
  
)

export default component.exports